import React, { Component } from "react";
import {
  TextCustom,
  RadioCustom,
  LabelCustom,
  SelectCustom,
  CheckboxCustom,
  AutocompleteCustom,
  AutocompleteCustomMulti,
  DatePickerCustom,
  ShowDataCustom,
  GenerateData,
  ButtonCustom, TextAreaCustom, TextOnlyCustom, NumberOnlyCustom, MultibuttonCustom,
  ConvertNumToWordCustom, MultiSelectCustom,
  HtmlTableCustom,
  FastPathContainer,
  //FullCalenderCustom,
  FileUploadCustom, SimpleModalCustom,
  CommonControlCustom, GenerateScheduleCustom,
  HrCustom, MagicDateCustom,
  DataListCustom,
  QRCodeScanner,
  CameraCustom,
  LinkCustom,
  EditorCustom,
  PieChartD3,
  IFrame,
  GoogleChart,
  FlatFootersGenerator,
  ProgressBarCustom,
  ProgressBarCustom1,
  ListWidget
} from "../FormComponents";
import KPIDisplay from "../FormComponents/KPIDisplay";
import FollowupList from "../FormComponents/FollowupList";
import KPIList from "../FormComponents/KPIList";
import KPITable from "../FormComponents/KPITable";
import DashboardsGenerator from "../FormComponents/DashboardsGenerator";
import NivoChart from "../FormComponents/NivoChart";
import BarChartCustom from "../FormComponents/BarChartCustom";
import { GoogleMap } from "../FormComponents/GoogleMap";


class AutoComponent extends Component {
  constructor(props) {
    super(props);
  }
  selectedValue() { }

  handleChange() { }

  render() {

    // console.log("AUTOCOMP")

    if (this.props.component.inputType === "text") {
      return (
        <TextCustom
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        // otherData={{errorMessages:this.props.parentState.errorMessages,currentPage:this.props.parentState.currentPage,currentValue:this.props.parentState[this.props.component.name],fileFolder:this.props.parentState.fileFolder,formState:this.props.parentState.formState}}
        //           errorMessages={this.props.parentState.errorMessages}
        // currentPage={this.props.parentState.currentPage}
        // currentValue={this.props.parentState[this.props.component.name]}
        // fileFolder={this.props.parentState.fileFolder}
        // formState={this.props.parentState.formState}
        />
      );
    }
    else if (this.props.component.inputType === "radio")
      return (
        <RadioCustom
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        />
      );
    else if (this.props.component.inputType === "hr")
      return (
        <HrCustom
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        />
      );
    else if (this.props.component.inputType === "displaytext")
      return (
        <LabelCustom
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        />
      );
    else if (this.props.component.inputType === "select")
      return (
        <SelectCustom
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        />
      );
    else if (this.props.component.inputType === "checkbox")
      return (
        <CheckboxCustom
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        />
      );
    else if (this.props.component.inputType === "autocomplete")
      return (
        <AutocompleteCustom
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        />
      );
    else if (this.props.component.inputType === "autocompletemulti")
      return (
        <AutocompleteCustomMulti
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          parentProps={this.props.parentProps}
        />
      );
    else if (this.props.component.inputType === "date")
      return (
        <DatePickerCustom
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        // otherData={{errorMessages:this.props.parentState.errorMessages,currentPage:this.props.parentState.currentPage,currentValue:this.props.parentState[this.props.component.name],fileFolder:this.props.parentState.fileFolder,formState:this.props.parentState.formState}}
        />
      );
    else if (this.props.component.inputType === "magicdate")
      return (
        <MagicDateCustom
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        // otherData={{errorMessages:this.props.parentState.errorMessages,currentPage:this.props.parentState.currentPage,currentValue:this.props.parentState[this.props.component.name],fileFolder:this.props.parentState.fileFolder,formState:this.props.parentState.formState}}
        />
      );

    if (this.props.component.inputType === "showdata") {
      return (
        <ShowDataCustom
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        />
      );
    }
    if (this.props.component.inputType === "gendata") {
      return (
        <GenerateData
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        />
      );
    }
    else if (this.props.component.inputType === "datalist") {
      return (
        <DataListCustom
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        />
      );
    }
    else if (this.props.component.inputType === "button")
      return (
        <ButtonCustom
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        />
      );
    else if (this.props.component.inputType === "multibutton")
      return (
        <MultibuttonCustom
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        />
      );


    else if (this.props.component.inputType === "textarea")
      return (
        <TextAreaCustom
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        />
      );
    else if (this.props.component.inputType === "textonly")
      return (
        <TextOnlyCustom
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        />
      );
    else if (this.props.component.inputType === "numberonly")
      return (
        <NumberOnlyCustom
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        />
      );

    else if (this.props.component.inputType === "numtoword")
      return (
        <ConvertNumToWordCustom
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        />
      );
    else if (this.props.component.inputType === "multiselect")
      return (
        <MultiSelectCustom
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        />
      );
    else if (this.props.component.inputType === "modalinput")
      return (
        <CommonControlCustom
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          parentProps={this.props.parentProps}
          conditionalRender={this.props.conditionalRender}
        />
      );
    else if (this.props.component.inputType === "schedule")
      return (
        <GenerateScheduleCustom
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          parentProps={this.props.parentProps}
          conditionalRender={this.props.conditionalRender}
        />
      );
    else if (this.props.component.inputType === "table") {
      return (
        <HtmlTableCustom
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        />
      );
    }
    else if (this.props.component.inputType === "fastpathContainer")
      return (
        <FastPathContainer
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        />
      );
    else if (this.props.component.inputType === "qrcode")
      return (
        <QRCodeScanner
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        />
      );
    else if (this.props.component.inputType === "camera")
      return (
        <CameraCustom
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        />
      );



    // else if (this.props.component.inputType === "fullCalender")
    // return (
    //   <FullCalenderCustom
    //     component={this.props.component}
    //     liftState={this.props.liftState}
    //     liftGlobalState={this.props.liftGlobalState}
    //     index={this.props.index}
    //     parentState={this.props.parentState}
    //     parentProps={this.props.parentProps}
    //   />
    // );
    else if (this.props.component.inputType === "fileupload")
      return (
        <FileUploadCustom
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          parentProps={this.props.parentProps}
          conditionalRender={this.props.conditionalRender}
        />
      );
    else if (this.props.component.inputType === "simplemodal")
      return (
        <SimpleModalCustom
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
        />
      );
    else if (this.props.component.inputType === "simpleeditor")
      return (
        <EditorCustom
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
        />
      );

    else if (this.props.component.inputType === "kpi")
      return (
        <KPIDisplay
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
        />
      );
    else if (this.props.component.inputType === "kpilist")
      return (
        <KPIList
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentProps={this.props.parentProps}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
        />
      );
    else if (this.props.component.inputType === "kpitable")
      return (
        <KPITable
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          parentProps={this.props.parentProps}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
        />
      );
    else if (this.props.component.inputType === "followuplist")
      return (
        <FollowupList
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
        />
      );
    else if (this.props.component.inputType === "link")
      return (
        <LinkCustom
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        />
      );
    else if (this.props.component.inputType === "piechart")
      return (
        <PieChartD3
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        />
      );
    else if (this.props.component.inputType === "iframe")
      return (
        <IFrame
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        />
      );
    else if (this.props.component.inputType === "gchart")
      return (
        <GoogleChart
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        />
      );

    else if (this.props.component.inputType === "gmapcustom")
      return (
        <GoogleMap
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        />
      );
    else if (this.props.component.inputType === "gmapwidget")
      return (
        <GoogleMap
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        />
      );
    else if (this.props.component.inputType === "flatFootersGenerator")
      return (
        <FlatFootersGenerator
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        />
      );
    else if (this.props.component.inputType === "dashboardsGenerator")
      return (
        <DashboardsGenerator
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        />
      );
    else if (this.props.component.inputType === "nivoChart")
      return (
        <NivoChart
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        />
      );
    else if (this.props.component.inputType === "barChart")
      return (
        <BarChartCustom
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        />
      );
    else if (this.props.component.inputType === "listwidget")
      return (
        <ListWidget
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        />
      );
    else if (this.props.component.inputType === "progressbarcustom")
      return (
        <ProgressBarCustom
          key={this.props.parentState.currentPage + this.props.index}
          component={this.props.component}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          index={this.props.index}
          parentState={this.props.parentState}
          conditionalRender={this.props.conditionalRender}
          parentProps={this.props.parentProps}
        />
      );
    return <div>No Component Defined.</div>;
  }
}

export default AutoComponent;
